import { Slot } from "@radix-ui/react-slot";
import { tv, type VariantProps } from "tailwind-variants";

import { TPolymorphicComponentProps } from "@/types";
import { cn } from "@marketing-sites/utils/cn";

const containerVariants = tv({
  base: "mx-auto w-full",
  variants: {
    size: {
      xs: "max-w-[720px]",
      sm: "md:max-w-[calc(100%/2*8)] lg:max-w-[calc(100%/12*6)]",
      base: "max-w-[1000px] lg:max-w-[calc(100%/12*10)]",
      lg: "max-w-[1600px]",
      xl: "max-w-[1920px]",
    },
    gutter: {
      true: "px-3 md:px-4",
    },
  },
  defaultVariants: {
    size: "base",
    gutter: true,
  },
});

type ContainerProps = React.ComponentProps<"div"> &
  TPolymorphicComponentProps &
  VariantProps<typeof containerVariants>;

const Container = ({
  className,
  size,
  gutter,
  dataTestId,
  ref,
  asChild = false,
  ...props
}: ContainerProps) => {
  const Comp = asChild ? Slot : "div";

  return (
    <Comp
      className={cn(containerVariants({ size, gutter, className }))}
      data-testid={dataTestId}
      ref={ref}
      {...props}
    />
  );
};

Container.displayName = "Container";

export { Container, containerVariants };
